
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import * as CookieConsent from 'vanilla-cookieconsent';

const Footer = () => {
  const { user } = useAuth();

  return (
    <footer className="bg-muted/20 dark:bg-muted/40 text-muted-foreground py-12 border-t">
      <div className="container mx-auto px-6">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h5 className="font-bold text-foreground mb-3">FAB (Forms And Backup)</h5>
            <p className="text-sm">
              Securely backing up your forms.
            </p>
          </div>
          <div>
            <h5 className="font-semibold text-foreground mb-3">Quick Links</h5>
            <ul className="space-y-2 text-sm">
              <li><Link to="/features" className="hover:text-foreground transition-colors">Features</Link></li>
              <li><Link to="/jotform-backup" className="hover:text-foreground transition-colors">Jotform Backup</Link></li>
              <li><Link to="/jotform-restore" className="hover:text-foreground transition-colors">Jotform Restore</Link></li>
              <li><Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link></li>
              <li><Link to="/help" className="hover:text-foreground transition-colors">Help Center</Link></li>
              <li><a href="mailto:support@fab.day" className="hover:text-foreground transition-colors">Contact Support</a></li>
              {!user && (
                <li><Link to="/auth?action=signup" className="hover:text-foreground transition-colors">Sign Up</Link></li>
              )}
            </ul>
          </div>
          <div>
            <h5 className="font-semibold text-foreground mb-3">Solutions</h5>
            <ul className="space-y-2 text-sm">
              <li><Link to="/agencies" className="hover:text-foreground transition-colors">For Agencies</Link></li>
              <li><Link to="/it-compliance" className="hover:text-foreground transition-colors">For IT &amp; Compliance</Link></li>
            </ul>
          </div>
          <div>
            <h5 className="font-semibold text-foreground mb-3">Company</h5>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-foreground transition-colors">About Us</Link></li>
              <li><Link to="/changelog" className="hover:text-foreground transition-colors">Changelog</Link></li>
              <li><Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-foreground transition-colors">Terms & Conditions</Link></li>
              {user && (
                <li><Link to="/customer-terms" className="hover:text-foreground transition-colors">Customer Terms</Link></li>
              )}
              <li><button onClick={() => CookieConsent.showPreferences()} className="hover:text-foreground transition-colors">Cookie Preferences</button></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-border text-center text-sm space-y-2">
          <p>&copy; {new Date().getFullYear()} FAB. All rights reserved.</p>
          <p className="text-xs text-muted-foreground/60">
            Logos provided by <a href="https://logo.dev" className="hover:text-foreground transition-colors">Logo.dev</a>
          </p>
          <p className="text-[10px] text-muted-foreground/40 max-w-2xl mx-auto leading-relaxed mt-4">
            FAB.DAY is an independent service and is not affiliated with, endorsed by, or sponsored by Jotform, FormAssembly, Typeform, Formstack, or Stripe. All product names, logos, and brands are property of their respective owners.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
